/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=39624182"
const script = {}

import exportComponent from "D:\\work\\官网\\conwaytech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__